import { Routes } from '@angular/router'

import { SEO_PAGE_DATA_NAME } from '~/core/constants'
import { NOT_FOUND_PATH } from '~const/index'

import { AnalystCoverageTabComponent } from './tabs/analyst-coverage-tab/analyst-coverage-tab.component'
import { MarketCupTabComponent } from './tabs/market-cup-tab/market-cup-tab.component'
import { SectorTabComponent } from './tabs/sector-tab/sector-tab.component'
import { ANALYST_COVERAGE_PATH, MARKET_CAP_PATH, SECTOR_PATH } from './constants'
import { PerformanceComponent } from './performance.component'

export const PERFORMANCE_ROUTES: Routes = [
  {
    path: '',
    component: PerformanceComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: MARKET_CAP_PATH,
      },
      {
        path: ANALYST_COVERAGE_PATH,
        component: AnalystCoverageTabComponent,
        data: {
          [SEO_PAGE_DATA_NAME]: {
            titleKey: 'seo.performance.analystCoverage.title',
            descriptionKey: 'seo.performance.analystCoverage.description',
            jsonLd: {
              type: 'WebPage',
              nameKey: 'seo.performance.analystCoverage.title',
              descriptionKey: 'seo.performance.analystCoverage.description',
            },
          },
        },
      },
      {
        path: MARKET_CAP_PATH,
        component: MarketCupTabComponent,
        data: {
          [SEO_PAGE_DATA_NAME]: {
            titleKey: 'seo.performance.marketCap.title',
            descriptionKey: 'seo.performance.marketCap.description',
            jsonLd: {
              type: 'WebPage',
              nameKey: 'seo.performance.marketCap.title',
              descriptionKey: 'seo.performance.marketCap.description',
            },
          },
        },
      },
      {
        path: SECTOR_PATH,
        component: SectorTabComponent,
        data: {
          [SEO_PAGE_DATA_NAME]: {
            titleKey: 'seo.performance.sector.title',
            descriptionKey: 'seo.performance.sector.description',
            jsonLd: {
              type: 'WebPage',
              nameKey: 'seo.performance.sector.title',
              descriptionKey: 'seo.performance.sector.description',
            },
          },
        },
      },
    ],
  },
  { path: '**', redirectTo: `/${NOT_FOUND_PATH}` },
]
